import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// Import your CreateContent component

import { useDispatch, useSelector } from "react-redux";
import {
	allStepsCompleted,
	handleReset,
} from "../../redux/slices/addNewContentStepsSlice";
import { steps } from "../../constants";
import { StepLabel } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { clearContentForm } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { resetAgreementForm } from "../../redux/slices/agreementFormSlice";
import { handleFilePicked } from "../../redux/slices/contentSlice/onedriveContent/onedriveContent";

export default function ContentCreationStepper() {
	const activeStep = useSelector(
		(state) => state.addNewContentSteps.activeStep
	);
	const completed = useSelector(
		(state) => state.addNewContentSteps.completed
	);
	const dispatch = useDispatch();
	const location = useLocation();

	const renderStepContent = (activeStep) => {
		const renderStep = steps.find(
			(step, stepIndex) => stepIndex === activeStep
		);

		if (renderStep) {
			return renderStep?.component;
		} else {
			return <Typography>Not Found 404</Typography>;
		}
	};

	const isMounted = useRef(false);
	useEffect(() => {
		return () => {
			// Dispatch reset action on unmount
			dispatch(resetAgreementForm());
			dispatch(clearContentForm());
			dispatch(handleReset());
		};
	}, [location.pathname]);

	return (
		<Box sx={{ width: "100%" }}>
			<Stepper nonLinear activeStep={activeStep} alternativeLabel>
				{steps.map((label, index) => (
					<Step key={index} completed={completed[index]}>
						<StepButton color="secondary" disabled>
							<StepLabel>{label?.label}</StepLabel>
						</StepButton>
					</Step>
				))}
			</Stepper>
			<div>
				{allStepsCompleted(steps) ? (
					<React.Fragment>
						<Typography sx={{ mt: 2, mb: 1 }}>
							All steps completed - you&apos;re finished
						</Typography>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								pt: 2,
							}}
						>
							<Box sx={{ flex: "1 1 auto" }} />
							<Button onClick={() => dispatch(handleReset())}>
								Reset
							</Button>
						</Box>
					</React.Fragment>
				) : (
					<React.Fragment>
						{renderStepContent(activeStep)}
					</React.Fragment>
				)}
			</div>
		</Box>
	);
}
